// File: /src/pages/Dashboard.js

import React from 'react';
import DashboardContent from '../components/DashboardContent';
import useDashboardData from '../hooks/useDashboardData';
import '../styles/Dashboard.css';

function Dashboard() {
	const data = useDashboardData();
	return <DashboardContent {...data} />;
}

export default Dashboard;
